import { Button } from '../components/ui/button';
import { useAuth } from '../contexts/AuthContext';

export function Unauthorized() {
  const { signOut } = useAuth();

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-2xl font-bold">Acceso denegado</h1>
      <p className="text-muted-foreground">Se requieren privilegios de administrador.</p>
      <Button variant="outline" onClick={() => void signOut()}>
        Cerrar sesión
      </Button>
    </div>
  );
}
